import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Flex, Image, Stack, Text, useSlotRecipe} from '@chakra-ui/react3'
import {CheckIcon, CancelIcon} from '../../../../../leap/components/icons'
import whatsIncludedRecipe from './whats-included.recipe'
import {getImageByViewType, getWhatsIncluded} from './utils'
import {useIntl} from 'react-intl'

const WhatsIncluded = ({product}) => {
    const recipe = useSlotRecipe({recipe: whatsIncludedRecipe})
    const {formatMessage} = useIntl()

    // Get images
    const whatsIncludedImage = product ? getImageByViewType(product, 'WhatsIncl') : null

    const styles = useMemo(
        () => recipe({hasImage: !!whatsIncludedImage}),
        [recipe, whatsIncludedImage]
    )

    if (!product) {
        return null
    }

    // Get additional data
    const whatsIncluded = getWhatsIncluded(product.c_whatsIncluded)

    return (
        <Flex css={styles.container}>
            <Flex css={styles.items}>
                <Stack css={styles.list}>
                    {whatsIncluded?.map((included) => (
                        <Flex css={styles.item} key={included.text}>
                            {included.iconFlag == 1 ? (
                                <CheckIcon
                                    color="icons.system.success"
                                    width={8}
                                    height={8}
                                    data-testid="check-icon"
                                />
                            ) : (
                                <CancelIcon
                                    color="icons.system.error"
                                    width={8}
                                    height={8}
                                    data-testid="close-icon"
                                />
                            )}
                            <Text css={styles.text}>{included.text}</Text>
                        </Flex>
                    ))}
                </Stack>
            </Flex>
            {whatsIncludedImage && (
                <Flex css={styles.imageWrapper}>
                    <Image
                        css={styles.image}
                        src={whatsIncludedImage.link}
                        alt={`${whatsIncludedImage.alt.split(',')[0]}, ${formatMessage({
                            id: 'pdp.module.specifications.included',
                            defaultMessage: "What's included"
                        })}`}
                        data-testid="whatsIncluded-image"
                    ></Image>
                </Flex>
            )}
        </Flex>
    )
}

WhatsIncluded.propTypes = {
    product: PropTypes.object
}

export default WhatsIncluded
